// removed by extract-text-webpack-plugin
module.exports = {"slick-slider":"_1VZg6bcy","slickSlider":"_1VZg6bcy","slick-list":"_19sy_KsS","slickList":"_19sy_KsS","dragging":"W7ONDdtL","slick-track":"_37WTEKiS","slickTrack":"_37WTEKiS","slick-loading":"_1gMyXIXI","slickLoading":"_1gMyXIXI","slick-slide":"bhFsjT7W","slickSlide":"bhFsjT7W","slick-initialized":"_2v6JV_vx","slickInitialized":"_2v6JV_vx","slick-vertical":"_1tIP9mvD","slickVertical":"_1tIP9mvD","slick-arrow":"_3hu6leIx","slickArrow":"_3hu6leIx","slick-hidden":"_1alKvyZh","slickHidden":"_1alKvyZh"};


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/slick.css
// module id = 776
// module chunks = 0